import React from 'react'
import { Stamp } from './style'

const dataTestLabel = 'stamp_cardelivery'
const StampExtendedCarDelivery = ({isDA=false}) => <Stamp data-test-component={dataTestLabel} isDA={isDA}></Stamp>

export default StampExtendedCarDelivery
